import React from "react";
import { Box, Divider, Link, Stack, Typography } from "@mui/material";
import { Outlet } from "react-router-dom";
import MImage from "components/@mui-extends/MImage";
import MenuIcon from "@mui/icons-material/Menu";

const listHeaderLink = [
  {
    link: "",
    title: "Wallet",
  },
  {
    link: "",
    title: "Fizen Pay",
  },
  {
    link: "",
    title: "Game Studio",
  },
  {
    link: "",
    title: "Stablecoin",
  },
  {
    link: "",
    title: "DAO",
  },
];

const discoverLink = [
  {
    link: "",
    title: "Team",
  },
  {
    link: "",
    title: "Media Kit",
  },
];

const appsLink = [
  {
    link: "",
    icon: "/assets/images/icons/app-store.svg",
  },
  {
    link: "",
    icon: "/assets/images/icons/google-play.svg",
  },
];

const RootLayout = () => {
  return (
    <Box
      sx={{
        position: "relative",
        background: `url("/assets/images/background/background2.png")`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ position: "absolute", top: 0, left: 0, width: "100%", py: 2, px: { xs: 2, lg: 7.5 } }}
      >
        <MImage src="/assets/images/icons/fizen-logo.svg" />
        <Stack
          direction="row"
          alignItems="center"
          spacing={3.75}
          divider={<Divider orientation="vertical" flexItem />}
          sx={{ display: { xs: "none", lg: "flex" } }}
        >
          <Stack direction="row" alignItems="center" spacing={3.75}>
            {listHeaderLink.map(({ link, title }) => (
              <Link
                href={link}
                target="_blank"
                rel="noreferrer noopener"
                underline="none"
                key={title}
              >
                <Typography
                  variant="text"
                  sx={{ color: "text.paper", "&:hover": { color: "warning.dark" } }}
                >
                  {title}
                </Typography>
              </Link>
            ))}
          </Stack>

          <Stack direction="row" alignItems="center" spacing={3.75}>
            {discoverLink.map(({ link, title }) => (
              <Link
                href={link}
                target="_blank"
                rel="noreferrer noopener"
                underline="none"
                key={title}
              >
                <Typography
                  variant="text"
                  sx={{ color: "text.paper", "&:hover": { color: "warning.dark" } }}
                >
                  {title}
                </Typography>
              </Link>
            ))}
          </Stack>

          <Stack direction="row" alignItems="center" spacing={3.75}>
            {appsLink.map(({ link, icon }) => (
              <Link
                href={link}
                target="_blank"
                rel="noreferrer noopener"
                underline="none"
                key={icon}
              >
                <MImage src={icon} />
              </Link>
            ))}
          </Stack>
        </Stack>
        <MenuIcon sx={{ display: { lg: "none" }, color: "white" }} />
      </Stack>
      <Outlet />
      <Stack
        direction="row"
        spacing={{ xs: 2, lg: 10 }}
        sx={{ position: "absolute", bottom: 20, width: "100%" }}
        justifyContent="center"
      >
        <Link
          href="/assets/legaldocs/Fizen-T&C.pdf"
          target="_blank"
          rel="noreferrer noopener"
          underline="none"
        >
          <Typography
            variant="text"
            sx={{ color: "text.subBody", "&:hover": { color: "warning.dark" } }}
          >
            Terms of Services
          </Typography>
        </Link>
        <Link
          href="/assets/legaldocs/Fizen-Policy.pdf"
          target="_blank"
          rel="noreferrer noopener"
          underline="none"
        >
          <Typography
            variant="text"
            sx={{ color: "text.subBody", "&:hover": { color: "warning.dark" } }}
          >
            Privacy Policy
          </Typography>
        </Link>
        <Typography
          variant="text"
          sx={{ color: "text.subBody", "&:hover": { color: "warning.dark" } }}
        >
          @ Fizen | Fizen Pay
        </Typography>
      </Stack>
    </Box>
  );
};

export default RootLayout;
